import * as React from "react";

type Props = {
  renderComponent: (
    open: boolean,
    setOpen: () => void,
    setClosed: () => void
  ) => React.ReactNode;
};

type State = {
  open: boolean;
};

export default class OpenCloseStateContainer extends React.PureComponent<
  Props,
  State
> {
  state = {
    open: false
  };

  setOpen = () =>
    this.setState({
      open: true
    });

  setClosed = () =>
    this.setState({
      open: false
    });

  render() {
    return this.props.renderComponent(
      this.state.open,
      this.setOpen,
      this.setClosed
    );
  }
}
